import React from 'react';
import styled from 'styled-components';
import SignUpForm from '../components/SignUp/SignUpForm';
import { useSelector, useDispatch } from 'react-redux';
import { AppState, UserCredentials, UserState } from '../types';
import { firebaseSignUp } from '../actions/user';
import { ErrorMsg } from '../constants/styles';
import { useHistory } from 'react-router';


const SignUpRoot = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-start;
align-items: center;
`;

export default function SignUp(props: {}) {
  const {
    signingUp,
    signUpError,
    signUpSuccess
  } = useSelector<AppState, UserState>(state => state.user);
  const history = useHistory();
  const dispatch = useDispatch();

  const signUp = (creds: UserCredentials) => dispatch(firebaseSignUp(creds));

  if (signUpSuccess) {
    setTimeout(function () {
      history.push('/login');
    }, 2000);
  }

  return (
    <SignUpRoot>
      <h1>
        Crear cuenta
      </h1>
      <SignUpForm
        handleSubmit={values => signUp(values)}
        signingUp={signingUp}
      />
      {
        signUpError && (
          <ErrorMsg>
            Error al crear la cuenta, por favor intenta de nuevo
          </ErrorMsg>
        )
      }
      {
        signingUp && (
          <p>Creando cuenta...</p>
        )
      }
      {
        signUpSuccess && (
          <p>Cuenta creada. Redirigiendo a inicio de sesión</p>
        )
      }
    </SignUpRoot>
  );
}